export default __webpack_public_path__ + "static/sales-pipeline-679549653a4e8226e37565c1f38ce041.mp4";